import { render, staticRenderFns } from "./docked-foldout.vue?vue&type=template&id=96e3a632&scoped=true&"
import script from "./docked-foldout.vue?vue&type=script&lang=ts&"
export * from "./docked-foldout.vue?vue&type=script&lang=ts&"
import style0 from "./docked-foldout.vue?vue&type=style&index=0&id=96e3a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e3a632",
  null
  
)

export default component.exports